import { BACKEND_URL } from "@/lib/api";

export const GOOGLE_ATTEMPT = "tps_google_attempt";
export const googleRegistrationKey = slug => `tps_google_registration:${slug}`;

export async function beginGoogle(studioSlug = "") {
  const bytes = crypto.getRandomValues(new Uint8Array(48));
  const verifier = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
  const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  const challenge = btoa(String.fromCharCode(...new Uint8Array(hash))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  const service = new URLSearchParams(window.location.search).get("service") || "";
  sessionStorage.setItem(GOOGLE_ATTEMPT, JSON.stringify({ verifier, studioSlug, service, brand: new URLSearchParams(window.location.search).get("brand") || "", professional: new URLSearchParams(window.location.search).get("professional") || "", service_type: new URLSearchParams(window.location.search).get("service_type") || "", campaign: new URLSearchParams(window.location.search).get("campaign") || "", gift: new URLSearchParams(window.location.search).get("gift") || "" }));
  const query = new URLSearchParams({ challenge, studio_slug: studioSlug, service });
  window.location.assign(`${BACKEND_URL}/api/auth/google?${query}`);
}

export function pendingGoogleRegistration(slug) {
  try {
    const item = JSON.parse(sessionStorage.getItem(googleRegistrationKey(slug)) || "null");
    if (item?.expiresAt > Date.now()) return item;
    sessionStorage.removeItem(googleRegistrationKey(slug));
  } catch { /* An inaccessible store requires a fresh Google sign-in. */ }
  return null;
}

